export default __webpack_public_path__ + "static/media/FVCChange.16c4454c.png";